import { Injectable, Signal, signal } from '@angular/core';
import { Claim } from './types';

@Injectable()
export class ClaimSetState {
  private readonly _byDocument = signal<Map<string, Claim[]>>(new Map());
  private readonly _activeClaim = signal<string | null>(null);

  readonly byDocument: Signal<ReadonlyMap<string, Claim[]>> = this._byDocument.asReadonly();
  readonly activeClaimId: Signal<string | null> = this._activeClaim.asReadonly();

  getForDocument(documentId: string): Claim[] {
    return this._byDocument().get(documentId) ?? [];
  }

  setForDocument(documentId: string, claims: Claim[]): void {
    this._byDocument.update((m) => {
      const next = new Map(m);
      next.set(documentId, claims);
      return next;
    });
  }

  findById(documentId: string, claimId: string): Claim | null {
    return this.getForDocument(documentId).find((c) => c.id === claimId) ?? null;
  }

  setActiveClaim(id: string | null): void {
    this._activeClaim.set(id);
  }
}
